import {APP_SITE_URL} from "../constans/global";
// @ts-ignore
import placeHolderImg from "../assets/images/placeholde-image.jpeg";
import {
    badgeType,
    BlogFileType,
    ClassStatusVideoProduct,
    CouponLimitType,
    CouponsValueType,
    EventFileType,
    FileType,
    GenderType,
    PaidStatus,
    priceType,
    ProductType,
    StatusVideoProduct,
    TeacherAttachmentType,
    TeacherSocialNetworkType,
    TicketSectionType,
    TicketStatusType,
    MethodPayment,
    TypeVideoProduct,
    UserType,
    VideoLinkType, TransactionWalletType, VideoProductLikeType
} from "../constans/enumTypes";
import {retry} from "@reduxjs/toolkit/query";

export const generateMediaLink = (value: string) => {
    return APP_SITE_URL + value
}

export const generateImageLink = (value: string) => {
    return isNotEmpty(value) ? generateMediaLink(value) : placeHolderImg
}

export const generatePriceGrade = (grade: number) => {
    switch (grade) {
        case priceType.GRADE_ONE:
            return "درجه 1"
        case priceType.GRADE_TWO:
            return "درجه 2"
        case priceType.GRADE_THREE:
            return "درجه 3"
    }
}

export const isNotEmpty = (value: any) => {
    return value !== null && value !== "";
}

export const isEmpty = (value: any) => {
    return value === null || value === "";
}

export const priceFormatWithUnitToman = (value: number): string => {
    return separateNumber(value / 10) + " تومان";
}

export const priceFormatWithUnitRial = (value: number): string => {
    return separateNumber(value) + " ریال"
}

export const separateNumber = (Number: any) => {
    Number += '';
    Number = Number.replace(',', '');
    let x = Number.split('.');
    let y = x[0];
    let z = x.length > 1 ? '.' + x[1] : '';
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(y))
        y = y.replace(rgx, '$1' + ',' + '$2');
    return y + z;
}

export const generateVideoLinkTypeTitle = (value: VideoLinkType) => {
    switch (value) {
        case VideoLinkType.KAVIMO:
            return "کاویمو"
        case VideoLinkType.LINK:
            return "لینک"
        default:
            return ""
    }
}

export const generateEventFileTypeTitle = (value: EventFileType) => {
    switch (value) {
        case EventFileType.NONE:
            return "هیچکدام"
        case EventFileType.AUDIO:
            return "صدا"
        case EventFileType.VIDEO:
            return "ویدیو"
        default:
            return ""
    }
}

export const generateBlogFileTypeTitle = (value: BlogFileType) => {
    switch (value) {
        case BlogFileType.NONE:
            return "هیچکدام"
        case BlogFileType.AUDIO:
            return "صدا"
        case BlogFileType.VIDEO:
            return "ویدیو"
        default:
            return ""
    }
}

export const generateUserTypeTitle = (value:UserType) => {
    switch (value) {
        case UserType.USER:
            return "کاربر"
        case UserType.ADMIN:
            return "پشتیبان"
        default:
            return ""
    }
}

export const generateTicketSectionTitle = (value:TicketSectionType) => {
    switch (value) {
        case TicketSectionType.SUPPORT:
            return "پشتیبانی"
        case TicketSectionType.TECHNICAL:
            return "فنی"
        case TicketSectionType.FINANCIAL:
            return "مالی"
        case TicketSectionType.EDUCATION:
            return "آموزش"
        default:
            return ""
    }
}

export const generateTicketStatusTitle = (value: TicketStatusType) => {
    switch (value) {
        case TicketStatusType.CHECK:
            return 'در حال بررسی'
        case TicketStatusType.ANSWER:
            return 'پاسخ داده شده'
        case TicketStatusType.QUESTION:
            return 'منتظر پاسخ'
        case TicketStatusType.CLOSE:
            return 'بسته شد'
        default:
            return '-'
    }
}

export const generateTicketStatus = (value: TicketStatusType) => {
    switch (value) {
        case TicketStatusType.CHECK:
            return badgeType.warning
        case TicketStatusType.ANSWER:
            return badgeType.info
        case TicketStatusType.QUESTION:
            return badgeType.error
        case TicketStatusType.CLOSE:
            return badgeType.success
        default:
            return badgeType.error
    }
}

export const generateProductTypeTitle = (value: ProductType) => {
    switch (value) {
        case ProductType.PACKAGE:
            return "پکیج"
        case ProductType.VIDEO:
            return "ویدیو"
        default:
            return ""
    }
}

export const generateCouponValueTypeTitle = (value: CouponsValueType) => {
    switch (value) {
        case CouponsValueType.PERCENT:
            return "درصد"
        case CouponsValueType.PRICE:
            return "قیمت"
        default:
            return ""
    }
}

export const generateCouponLimitTypeTitle = (value:CouponLimitType) => {
    switch (value){
        case CouponLimitType.ALL_BASKET:
            return "کل سبد خرید"
        case CouponLimitType.BEFORE_PRODUCT:
            return "محصول خریداری شده از قبل"
        case CouponLimitType.FIRST_PRODUCT:
            return "اولین خرید"
        case CouponLimitType.SPECIAL_PRODUCT:
            return "محصول خاص"
        default:
            return ""
    }
}

export const generateTypeVideoProductTitle = (value: TypeVideoProduct) => {
    switch (value) {
        case TypeVideoProduct.COURSE:
            return "دوره"
        case TypeVideoProduct.FREE:
            return "محصول رایگان"
        case TypeVideoProduct.PRODUCT:
            return "محصول"
        case TypeVideoProduct.WEBINAR:
            return "وبینار"
        default:
            return ""
    }
}

export const generateStatusVideoProductTitle = (value: StatusVideoProduct) => {
    switch (value) {
        case StatusVideoProduct.DONE:
            return "تکمیل شده"
        case StatusVideoProduct.RECORDED:
            return "درحال ضبط"
        case StatusVideoProduct.PERFORMING:
            return "در حال برگزاری"
        case StatusVideoProduct.REGISTERING:
            return "در حال ثبت نام"
        default:
            return ""
    }
}

export const generateClassStatusVideoProductTitle = (value: ClassStatusVideoProduct) => {
    switch (value) {
        case ClassStatusVideoProduct.DONE:
            return "انجام شد"
        case ClassStatusVideoProduct.PERFORMING:
            return "در حال برگزاری"
        default:
            return ""
    }
}

export const generateGenderTypeTitle = (value: GenderType) => {
    switch (value){
        case GenderType.MALE:
            return "مرد"
        case GenderType.FEMALE:
            return "زن"
        default:
            return ""
    }
}

export const generateTeacherSocialNetworkTitle = (value: TeacherSocialNetworkType) => {
    switch (value){
        case TeacherSocialNetworkType.EMAIL:
            return "ایمیل"
        case TeacherSocialNetworkType.INSTAGRAM:
            return "اینستاگرام"
        case TeacherSocialNetworkType.TELEGRAM:
            return "تلگرام"
        case TeacherSocialNetworkType.WEBSITE:
            return "وبسایت"
        case TeacherSocialNetworkType.WHATSAPP:
            return "واتساپ"
        default:
            return ""
    }
}

export const generateTeacherAttachmentTitle = (value: TeacherAttachmentType) => {
    switch (value) {
        case TeacherAttachmentType.FILE:
            return "فایل"
        case TeacherAttachmentType.IMAGE:
            return "عکس"
        default:
            return ""
    }
}

export const generateFileTypeTitle = (value: FileType) => {
    switch (value) {
        case FileType.AUDIO:
            return "صوت"
        case FileType.VIDEO:
            return "ویدیو"
        case FileType.FILE:
            return "فایل"
        default:
            return ""
    }
}

export const generatePaidStatusTitle = (value: PaidStatus) => {
    switch (value){
        case PaidStatus.DONE:
            return "پرداخت شده"
        case PaidStatus.FAILED:
            return "پرداخت نشده"
        default:
            return
    }
}

export const generateMethodPaymentTitle = (value: MethodPayment) => {
    switch (value){
        case MethodPayment.ONLINE:
            return "آنلاین"
        case MethodPayment.WALLET:
            return "کیف پول"
        default:
            return
    }
}

export const generateTransactionWalletTypeTitle = (value:TransactionWalletType) => {
    switch (value) {
        case TransactionWalletType.WITHDRAW:
            return "برداشت"
        case TransactionWalletType.DEPOSIT:
            return "واریز"
        default:
            return ""
    }
}

export const generateVideoProductLikeTypeTitle = (value: VideoProductLikeType) => {
    switch (value){
        case VideoProductLikeType.LIKE:
            return 'پسندیدن'

        case VideoProductLikeType.DISLIKE:
            return 'نپسندیدن'

        default:
            return
    }
}
